// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7174da18","952":"4ba69500"}[chunkId] + ".chunk.js";
};